export const SetupLayoutGeneric = () => {
    return (
        <></>
    )
};